import ActivityTable from 'components/molecules/activity-table';
import { useEffect, useState, type FC } from 'react';
import {
  useRpmPatientActivity,
  useSocketActions,
} from 'infrastructure/hooks/rpm';
import { usePatientInfo } from 'infrastructure/hooks/patient/use-patient-info';
import { usePatientDevices } from 'infrastructure/hooks/device/use-patient-devices';
import { useAppSelector } from 'store';
import { BroadcastTopics } from 'services/wsService';
import { ModuleType } from 'infrastructure/enums';

import type { IUpdateReadingAction } from 'infrastructure/interfaces/i-rpm-patient-activity';

interface ErroneousReadingsProps {
  patientGuid: string;
}

const ErroneousReadings: FC<ErroneousReadingsProps> = ({ patientGuid }) => {
  const [sortByDate, setSortByDate] = useState(false);
  const [page, setPage] = useState(1);
  const { patientInfo, loading: patientInfoLoading } = usePatientInfo({
    patientGuid,
  });
  const { loading, devices } = usePatientDevices({ patientGuid });
  const deviceIds = devices?.map((device) => device.deviceId).join(',') ?? '';
  const {
    activity,
    isLoading: isLoadingActivity,
    isFetching: isFetchingActivity,
    queryKey,
  } = useRpmPatientActivity({
    clinicGuid: patientInfo?.clinicGuid,
    deviceIds,
    patientGuid,
    reverse: sortByDate,
    onlyIsErroneous: true,
    applyLinkedCalls: true,
    meta: { page, items: 10 },
  });

  const { onActionChange } = useSocketActions(queryKey);
  const socket = useAppSelector((state) => state.socket);

  const onSort = (field: string) => {
    if (field === 'createdAt') setSortByDate((prev) => !prev);
    if (field === '') setSortByDate(false);
  };

  useEffect(() => {
    if (socket.client && socket.isConnected) {
      socket.client.on(
        BroadcastTopics.NewReadingAction,
        (data: IUpdateReadingAction) => {
          onActionChange({ ...data, newAction: true });
        },
      );
    }

    return () => {
      if (socket.client && socket.isConnected === true) {
        socket.client.off(BroadcastTopics.NewReadingAction);
      }
    };
  }, [socket]);

  const isLoading =
    patientInfoLoading || loading || isLoadingActivity || isFetchingActivity;

  return (
    <ActivityTable
      activity={activity}
      loading={isLoading}
      page={page}
      setPage={setPage}
      itemsQueryKey={queryKey}
      view="admin"
      onSort={onSort}
      pageSize={10}
      module={ModuleType.ADMIN}
    />
  );
};
export default ErroneousReadings;
